import React from 'react';

import { AuthProvider } from '@propelauth/react';
import { PostHogProvider } from 'posthog-js/react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';
import posthog from './services/analytics/posthog';
import { initFaroWithRouter } from './services/faro/faroRouter';
import 'reset-css';
import './services/sentry';

initFaroWithRouter();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

if (!process.env.REACT_APP_AUTH_URL) {
  throw new Error('REACT_APP_AUTH_URL environment variable is not set');
}

root.render(
  <React.StrictMode>
    <AuthProvider authUrl={process.env.REACT_APP_AUTH_URL}>
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
